var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-swipe',{staticClass:"my-swipe",attrs:{"autoplay":3000,"indicator-color":"white"}},_vm._l((_vm.swiperList),function(item,index){return _c('van-swipe-item',{key:item.index},[_c('img',{attrs:{"src":item.src,"alt":""}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }